import React from 'react';

const Rocket = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="36"
    viewBox="0 0 14 36"
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#B3DAF3" d="M1.253 16.955v6.768l3.168-2.425v-6.769z" />
      <path
        stroke="#287CB8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".75"
        d="M4.42 21.298l-3.167 2.425v-6.768l3.168-2.426z"
      />
      <path
        fill="#B3DAF3"
        d="M10.067 21.298l3.168 2.425v-6.769l-3.168-2.425z"
      />
      <path
        stroke="#287CB8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".75"
        d="M13.235 16.955l-3.168-2.426v6.769l3.168 2.425z"
      />
      <path
        fill="#70B4E3"
        d="M10.098 21.278c.55-1.12 1.741-6.54 1.741-9.072C11.84 5.823 7.231.252 7.231.252S2.622 5.823 2.622 12.206c0 2.532 1.19 7.952 1.742 9.072h5.734z"
      />
      <path
        stroke="#287CB8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".75"
        d="M10.098 21.278c.55-1.12 1.741-6.54 1.741-9.072C11.84 5.823 7.231.252 7.231.252S2.622 5.823 2.622 12.206c0 2.532 1.19 7.952 1.742 9.072h5.734z"
      />
      <path
        fill="#FEFEFE"
        d="M8.781 8.39a1.55 1.55 0 1 1-3.1 0 1.55 1.55 0 0 1 3.1 0"
      />
      <path
        stroke="#287CB8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".75"
        d="M8.781 8.39a1.55 1.55 0 1 1-3.1 0 1.55 1.55 0 0 1 3.1 0zM7.231 17.354v6.769M4.42 26.404v6.056M9.939 26.404v6.056M7.111 27.461v8.028"
      />
    </g>
  </svg>
);

export default Rocket;
